// extracted by mini-css-extract-plugin
export default {"tooltip":"E0-z","arrow":"F0-z"};